import { render, staticRenderFns } from "./POSTable.vue?vue&type=template&id=9d518bb2&scoped=true"
import script from "./POSTable.vue?vue&type=script&lang=js"
export * from "./POSTable.vue?vue&type=script&lang=js"
import style0 from "./POSTable.vue?vue&type=style&index=0&id=9d518bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d518bb2",
  null
  
)

export default component.exports